import React, { useRef, useEffect, useCallback } from 'react';
import { useSpring, animated } from 'react-spring';
import styled from 'styled-components';
import CloudImage from '../assets/images/cloud.png';
import PlaneImage from '../assets/images/plane.png';
import Close from '../assets/images/close.svg';
import UpScroll from '../assets/images/up-scroll.svg';
import DownScroll from '../assets/images/down-scroll.svg';
import { Modal } from '@mui/material';
// import Box from '@mui/material/Box';
import { notify, translateNum } from '../const';
import { config } from '../environment';
import { useTranslation } from 'react-i18next';

// const style = {
//     position: 'absolute',
//     top: '40%',
//     left: '50%',
//     transform: 'translate(-50%, -50%)',
//     maxWidth: '635px',
//     bgcolor: 'background.paper',
//     border: '2px solid #000',
//     borderRadius: '10px',
//     boxShadow: 24,
//     background: '#80D1E9',
//     padding: '40px',
// };

const Background = styled.div`
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.1);
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow-y: scroll;
    ::-webkit-scrollbar {
        display: none;
    }
`;

const ModalWrapper = styled.div`
    width: 80vw;
    height: 100%;
    max-height: 700px;
    min-height: 80vh;
    max-width: 1400px;
    box-shadow: 0 5px 16px rgba(0, 0, 0, 0.2);
    background: #8bd1eb;
    border: 1px solid #707070;
    color: #000;
    display: grid;
    position: relative;
    z-index: 10;
    border-radius: 15px;
    @media screen and (max-width: 1024px) {
      min-height: unset;
    }
`;

const CloudImage1 = styled.img`
    position: absolute;
    height: 100px;
    top: -50px;
    right: 25%;
    @media screen and (max-width: 768px) {
        height: 50px;
        top: -30px;
    }
`;
const CloudImage2 = styled.img`
    position: absolute;
    height: 80px;
    right: -50px;
    bottom: 25%;
    @media screen and (max-width: 768px) {
        height: 40px;
        right: -30px;
    }
`;
const CloudImage3 = styled.img`
    position: absolute;
    height: 80px;
    left: -70px;
    top: 20%;
    @media screen and (max-width: 768px) {
        height: 40px;
        left: -30px;
    }
`;
const CloudImage4 = styled.img`
    position: absolute;
    height: 100px;
    bottom: -35px;
    left: 25%;
    @media screen and (max-width: 768px) {
        height: 50px;
        bottom: -20px;
    }
`;
const ModalContent = styled.div`
    display: flex;
    align-items: center;
    line-height: 1.8;
    color: #141414;
    h1 {
        color: #212121;
        font-size: 35px;
        font-weight: 900;
        font-family: 'Bungee', cursive;
        margin: 0;
        &.value {
            color: #ffffff;
            margin-left: 10px;
        }
        @media screen and (max-width: 1240px) {
            font-size: 26px;
        }
        @media screen and (max-width: 1024px) {
            font-size: 22px;
        }
        @media screen and (max-width: 577px) {
            font-size: 16px;
        }
    }
    @media screen and (max-width: 768px) {
        flex-direction: column;
    }
`;
const CloseModalButton = styled.p`
    cursor: pointer;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 10px;
    right: 20px;
    width: 35px;
    height: 35px;
    &::after {
        content: '';
        width: 0;
        height: 0;
        position: absolute;
        border-radius: 50%;
        background-color: #212121;
        z-index: -1;
        transition: all 0.5s ease-in-out;
    }
    &:hover::after {
        width: 40px;
        height: 40px;
    }
    @media screen and (max-width: 577px) {
        top: -5px;
        right: 8z px;
    }
`;
const TopContent = styled.div`
    width: 50%;
    margin: 40px 0;
    gap: 20px;
    /* padding: 50px 0; */
    display: flex;
    flex-direction: column;
    justify-content: center;
    @media screen and (max-width: 768px) {
        padding: 0;
        width: 100%;
        flex-direction: column !important;
        width: unset;
        margin: 0px;
        gap: 0px;
    }
`;
const Plane = styled.img`
    height: 120px;
    object-fit: contain;
    @media screen and (max-width: 1240px) {
        margin-left: 20px;
        height: 100px;
    }
    @media screen and (max-width: 1024px) {
        height: 80px;
    }
    @media screen and (max-width: 768px) {
        margin-top: 30px;
        height: 80px;
        object-fit: contain;
    }
`;
const Card = styled.a`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: white;
    border: 5px solid #212121;
    margin-bottom: 30px;
    padding: 0px 20px;
    text-decoration: none;
    transition: all 0.2s ease-in-out;
    h2 {
        color: #212121;
        font-size: 35px;
        font-weight: 500;
        font-family: 'Bungee', cursive;
        margin: 0;
        text-align: center;
    }
    @media screen and (max-width: 1240px) {
        height: 50px;
        h2 {
            color: #212121;
            font-size: 35px;
            font-weight: 900;
            font-family: 'Bungee', cursive;
            margin: 0;
        }
    }
    @media screen and (max-width: 1240px) {
        h2 {
            font-size: 20px;
        }
    }
    @media screen and (max-width: 768px) {
        flex-direction: row;
        height: 45px;
        margin: 10px 0 10px 0;
        border: 4px solid #212121 ;
    }
    @media screen and (max-width: 577px) {
        height: 30px;
        border: 3px solid #212121 !important;
        h2 {
            font-size: 13px;
        }
    }
`;
const BottomContent = styled.div`
    margin-top: 20px;
    width: 50%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin: 50px 0;

    @media screen and (max-width: 768px) {
        justify-content: center;
        width: 100%;
        margin: 20px 0 40px 0;
    }
    @media screen and (max-width: 577px) {
        flex-direction: column;
        margin: 0px 0 40px 0;
    }
`;
const CreditContent = styled.div`
    display: flex;
    position: relative;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    @media screen and (min-width: 578px) and (max-width: 768px) {
        margin-left: 60px;
    }
`;

const Button = styled.button`
    background-color: #fed743 !important;
    border: 5px solid #212121 !important;
    margin: 10px;
    color: #212121;
    font-size: 25px;
    font-weight: 900;
    font-family: 'Bungee', cursive;
    width: fit-content;
    cursor: pointer;
    width: 430px;
    height: 70px;
    line-height: 30px;

    @media screen and (max-width: 1240px) {
        height: 60px;
        width: 300px;
        font-size: 17px;
    }
    @media screen and (max-width: 1024px) {
        height: 50px;
        width: 270px;
        font-size: 15px;
    }
    @media screen and (max-width: 768px) {
        height: 50px;
        margin: 5px;
        border: 4px solid #212121 !important;
    }
    @media screen and (max-width: 577px) {
        width: 230px;
        height: 40px;
        font-size: 12px;
        border: 3px solid #212121 !important;
    }
`;

// const Tags = styled.div`
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     position: absolute;
//     border-radius: 50%;
//     border: 4px solid #212121;
//     &.best-value {
//         top: 40px;
//         right: -50px;
//         height: 75px;
//         width: 75px;
//         background-color: #e4332a;
//     }
//     &.popular {
//         bottom: 70px;
//         left: -50px;
//         height: 80px;
//         width: 80px;
//         background-color: #00af4d;
//     }
//     p {
//         font-size: 13px;
//         color: white;
//         font-weight: 300;
//         text-align: center;
//         line-height: 17px;
//     }
//     @media screen and (max-width: 1024px) {
//         &.best-value {
//             height: 60px;
//             width: 60px;
//             top: 30px;
//             right: -20px;
//         }
//         &.popular {
//             height: 65px;
//             width: 65px;
//             left: -40px;
//             bottom: 50px;
//         }
//         p {
//             font-size: 11px;
//         }
//     }
// `;

const ScrollContainer = styled.div`
    display: flex;
    gap: 25px;
    flex-direction: column;
    margin-right: 30px;
    img {
        height: 30px;
        cursor: pointer;
        @media screen and (max-width: 1024px) {
            height: 18px;
        }
    }
    @media screen and (max-width: 577px) {
        flex-direction: row;
        gap: 0px;
        margin: 10px 0 0 0;
        padding: 10px 5px;
        border-radius: 5px;
        background-color: white;
        img {
            height: 20px !important;
            padding: 0 5px;
            &:first-child {
                border-right: 1px solid #ccc;
            }
        }
    }
`;
export const BuyCreditModal = ({
    showModal,
    setShowModal,
    credits,
    buyCredits,
    tamaBalance,
    token,
}) => {
    const modalRef = useRef();
    const { t } = useTranslation();

    const animation = useSpring({
        config: {
            duration: 200,
        },
        opacity: showModal ? 1 : 0,
    });
    const keyPress = useCallback(
        (e) => {
            if (e.key === 'Escape' && showModal) {
                setShowModal(false);
            }
        },
        [setShowModal, showModal]
    );

    useEffect(() => {
        document.addEventListener('keydown', keyPress);
        return () => document.removeEventListener('keydown', keyPress);
    }, [keyPress]);

    return (
        <>
            {showModal ? (
                <Modal
                    open={showModal}
                    aria-labelledby='modal-modal-title'
                    aria-describedby='modal-modal-description'
                >
                    {/* <Box sx={style}> */}
                    <Background ref={modalRef}>
                        <animated.div style={animation}>
                            <ModalWrapper showModal={showModal}>
                                <ModalContent>
                                    <CloudImage1 src={CloudImage} alt='cloud' />
                                    <CloudImage2 src={CloudImage} alt='cloud' />
                                    <CloudImage3 src={CloudImage} alt='cloud' />
                                    <CloudImage4 src={CloudImage} alt='cloud' />
                                    <TopContent>
                                        <Plane src={PlaneImage} alt='plane' />
                                        {token && (
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    flexDirection: 'column',
                                                }}
                                            >
                                                <div
                                                    style={{ display: 'flex' }}
                                                >
                                                    <h1>{t('tama_balance')}</h1>
                                                    <h1 className='value'>
                                                        {translateNum(
                                                            tamaBalance
                                                        )}
                                                    </h1>
                                                </div>
                                                <div
                                                    style={{ display: 'flex' }}
                                                >
                                                    <h1>
                                                        {t('credit_balance')}
                                                    </h1>
                                                    <h1 className='value'>
                                                        {translateNum(credits)}
                                                    </h1>
                                                </div>
                                            </div>
                                        )}
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                flexDirection: 'column',
                                            }}
                                        >
                                            <Card
                                                href='https://tamadoge.io/tokens/'
                                                target='_blank'
                                            >
                                                <h2>{t('buy_with_card')}</h2>
                                            </Card>
                                            <Card
                                                href='https://tamadoge.io/tokens/'
                                                target='_blank'
                                            >
                                                <h2>{t('buy_with_crypto')}</h2>
                                            </Card>
                                        </div>
                                    </TopContent>
                                    <BottomContent>
                                        <CreditContent>
                                            <h1>{t('buy_credit_bundles')}</h1>
                                            {/* <Tags className='best-value'>
                                                <p>{t('best_value')}</p>
                                            </Tags>
                                            <Tags className='popular'>
                                                <p>{t('most_popular')}</p>
                                            </Tags> */}
                                            {config.creditsPlans &&
                                                config.creditsPlans.map(
                                                    (ele, i) =>
                                                        ele.isActive ? (
                                                            <Button
                                                                onClick={() =>
                                                                    `${
                                                                        process
                                                                            .env
                                                                            .REACT_APP_BETA_TESTING ===
                                                                        'true'
                                                                            ? notify(
                                                                                  'This feature is coming soon',
                                                                                  'warning'
                                                                              )
                                                                            : token
                                                                            ? buyCredits(
                                                                                  i +
                                                                                      1,
                                                                                  ele.tamaRequired,
                                                                                  ele.arcadeCredits
                                                                              )
                                                                            : notify(
                                                                                  'Please connect your wallet',
                                                                                  'warning'
                                                                              )
                                                                    }`
                                                                }
                                                                key={i}
                                                            >
                                                                {/* {ele.tamaRequired} {t('tama_for')}{' '}{ele.arcadeCredits}C */}
                                                                {translateNum(ele.arcadeCredits)} {t('credits')} = {translateNum(ele.tamaRequired)}  {t('tama')}
                                                            </Button>
                                                        ) : (
                                                            ''
                                                        )
                                                )}
                                        </CreditContent>
                                        <ScrollContainer>
                                            <img src={UpScroll} alt='close' />
                                            <img src={DownScroll} alt='close' />
                                        </ScrollContainer>
                                    </BottomContent>
                                </ModalContent>
                                <CloseModalButton
                                    onClick={() =>
                                        setShowModal((prev) => !prev)
                                    }
                                >
                                    <img
                                        src={Close}
                                        style={{ height: 20 }}
                                        alt='close'
                                    />
                                </CloseModalButton>
                            </ModalWrapper>
                        </animated.div>
                    </Background>
                    {/* </Box> */}
                </Modal>
            ) : null}
        </>
    );
};
